export const apiFetch = async (endpoint, options = {}) => {
  let response;
  let data;

  const reload = () => {
    window.location.href = "./acceso";
  }

  try {
    response = await fetch(endpoint, options);
    const clonedResponse = response.clone();
    try {
      data = await clonedResponse.json();
    } catch (parseError) {
      alert("Error al parsear la respuesta de la API como JSON:", parseError);
      if (!response.ok) { 
        reload(); 
      }
      return response;
    }
    
    if (response.ok && data.estatus === "error" && (data.mensaje === "No hay sesión iniciada" || data.mensaje === "Sesión inválida")) {
        alert("Se venció la sesión, regresando al login...");
        reload();
    }

    if (!response.ok) {
        alert("Hay un problema con el servidor, intentalo de nuevo mas tarde.")
        reload(); 
    }
    return response;

  } catch (err) {
    alert("Error en la petición de red:", err);
    throw err;
  }
};